export default function IconEllipses({ className }: { className?: string }) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g>
        <circle cx="7" cy="12" r="1.75"></circle>
        <circle cx="12" cy="12" r="1.75"></circle>
        <circle cx="17" cy="12" r="1.75"></circle>
      </g>
    </svg>
  )
}
